module.exports = "/_next/static/images/05ab19616f3bf7eac3a99a00e77b2af8-monthly-payments-lg.jpg";